import e from "../../hooks/useClickOutside.js";
import t from "../../utils/classNames.js";
import { useAnchorName as n, usePopover as r } from "../../hooks/useAnchoredPopover.js";
import { forwardRef as i, useRef as a, useState as o } from "react";
import { isEmpty as s, noop as c } from "es-toolkit/compat";
import { jsx as l, jsxs as u } from "react/jsx-runtime";
//#region src/components/applicationHeader/AppMenuDropdown.tsx
var d = (e) => {
	let { title: n, caret: r } = e, i = t("ModuleNavigation-dropdown", "dropdown-toggle justify-content-between", !r && "inactive");
	return /* @__PURE__ */ u("a", {
		className: i,
		role: "button",
		id: "basic-nav-dropdown",
		children: [/* @__PURE__ */ l("span", { children: n }), r && /* @__PURE__ */ l("span", { className: "caret" })]
	});
}, f = (e) => {
	let { children: t, open: n, anchorName: i } = e, o = a(null);
	return r(o, n), s(t) ? null : /* @__PURE__ */ l("ul", {
		popover: "manual",
		role: "menu",
		className: "dropdown-menu ModuleNavigation-dropdown-menu",
		ref: o,
		style: { positionAnchor: i },
		children: t
	});
}, p = i((e, n) => {
	let { open: r, anchorName: i, children: a, onDropdownClick: o } = e, s = { anchorName: i };
	return /* @__PURE__ */ l("li", {
		ref: n,
		className: t("dropdown", r && "open"),
		onClick: o,
		style: s,
		children: a
	});
}), m = (t) => {
	let { title: r, caret: i = !1, onToggleAppMenu: a = c, children: m } = t, [h, g] = o(!1), _ = n("application-header-menu"), v = e(() => g(!1)), y = () => {
		let e = !h;
		g(e), a(e);
	}, b = !s(m) && h;
	return /* @__PURE__ */ u(p, {
		open: b,
		anchorName: _,
		onDropdownClick: y,
		ref: v,
		children: [/* @__PURE__ */ l(d, {
			title: r,
			caret: i
		}), /* @__PURE__ */ l(f, {
			open: b,
			anchorName: _,
			children: m
		})]
	});
};
//#endregion
export { m as AppMenuDropdown, m as default };

//# sourceMappingURL=AppMenuDropdown.js.map